import { Box, Pressable, Text, useColorModeValue } from "native-base";
import React, { useEffect, useMemo, useState } from "react";
import { NavigationState, SceneMap, SceneRendererProps, TabView } from "react-native-tab-view";

type TabBarProps = {
  scenes: {
    key: string;
    title: string;
    component: () => JSX.Element;
  }[];
};

const TabBar = ({ scenes }: TabBarProps) => {
  const [index, setIndex] = useState(0);
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    setRoutes(
      scenes.map((scene) => ({
        key: scene.key,
        title: scene.title,
      }))
    );
  }, [scenes]);

  const renderScene = useMemo(() => {
    return SceneMap(scenes.reduce((acc, scene) => ({ ...acc, [scene.key]: scene.component }), {}));
  }, [scenes]);

  const renderTabBar = (
    props: SceneRendererProps & {
      navigationState: NavigationState<any>;
    }
  ) => {
    return (
      <Box flexDirection="row">
        {props.navigationState.routes.map((route, i) => {
          const borderColor =
            index === i ? "primary.600" : useColorModeValue("coolGray.200", "gray.400");
          return (
            <Box borderBottomWidth="3" borderColor={borderColor} flex={1} alignItems="center" p="3">
              <Pressable
                onPress={() => {
                  setIndex(i);
                }}>
                <Text fontSize="md" color="primary.600" isTruncated bold={index === i}>
                  {route.title}
                </Text>
              </Pressable>
            </Box>
          );
        })}
      </Box>
    );
  };

  return (
    <TabView
      navigationState={{
        index,
        routes,
      }}
      renderScene={renderScene}
      renderTabBar={renderTabBar}
      onIndexChange={setIndex}
    />
  );
};

export default TabBar;
